import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { useDispatch, useSelector } from "react-redux";
import theme from "../../../Utils/theme";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import deleteIcon from "../../../assets/icon/trash-solid.svg";
import Fontstyling, { tablestyle } from "../../../components/common/comman";
import { Link } from "react-router-dom";
import moment from "moment";
import Loader from "../../../components/common/Loader";
import NoDataMassage from "../../../components/common/NoDataMassage";
import RebatesAndReimbursementsModal from "../../../components/common/Modal/RebatesAndReimbursementsModal.js";
import { GetClientsRebatesAndReimbursementsDetails } from "../../../api/User/Hub/RebatesAndReimbursementsApi";
import toastFile from "../../../Service/ToastFile";
import DetailsHeader from "../../../components/common/Hub/DetailsHeader";
import CustomMaterialTable from "../../../components/common/CustomMaterialTable";

const RebatesAndReimbursements = ({ navigate }) => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [updateData, setUpdateData] = useState({});
  const [responseMessage, setResponseMessage] = useState("");
  const [witchAction, setWitchAction] = useState("add");
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    {
      title: "Plan Type",
      field: "CategoryType",
    },
    {
      title: "Plan Name",
      field: "PlanName",
    },
    {
      title: "Date",
      field: "Date",
      render: (rowData) => moment(rowData.Date).format("MM-DD-yyyy"),
    },
    {
      title: "Amount",
      field: "Amount",
      render: (rowData) => "$" + rowData.Amount,
    },
  ];


 
  useEffect(() => {
    if (!modalShow) {
      setWitchAction("add");
    }
  }, [modalShow]);

  useEffect(() => {
    if (responseMessage === "new") {
      toastFile("New Rebates And Reimbursements added", "success");
    }
    if (responseMessage === "update") {
      toastFile("Rebates And Reimbursements updated", "success");
    }
    if (responseMessage === "delete") {
      toastFile("Rebates And Reimbursements deleted", "success");
    }
    if (responseMessage === "rejectedRegion") {
      toastFile("Requested region is rejected select different client");
    }
    if (responseMessage === "failed") {
      toastFile("Failed to save..!!");
    }
    getRebatesAndReimbursementsData();
    setResponseMessage("");
  }, [responseMessage, client]);

  const getRebatesAndReimbursementsData = () => {
    if (client !== null) {
      setIsLoading(true);
      GetClientsRebatesAndReimbursementsDetails(
        client?.clientID,
        user?.UD_id
      ).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
          setIsLoading(false);
        }
      });
    }
  };

  return (
    <>
      <RebatesAndReimbursementsModal
        show={modalShow}
        onHide={() => {
          setUpdateData({});
          setModalShow(false);
        }}
        witchAction={witchAction}
        user={user}
        client={client}
        updateData={updateData}
        setResponseMessage={setResponseMessage}
        getData={getRebatesAndReimbursementsData}
      />
      <DetailsHeader setModalShow={setModalShow} setWitchAction={setWitchAction} page={"rebatesandreimbursements"}/>
      <div className="mb-4" style={Fontstyling.heading}>
        Rebates And Reimbursements Details:
      </div>
      <CustomMaterialTable
        isExport={false}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setUpdateData}
        setShowModal={setModalShow}
        isLoading={isLoading}
      />
      <div className="d-md-flex d-block align-items-center gap-3 mt-3">
        <Link
          className="text-nowrap"
          style={{ ...Fontstyling.savebutton, textDecoration: "none" }}
          to={"/HUBExperience/importcarrierfile"}
        >
          Save & Continue
        </Link>
        {/* <button style={Fontstyling.cancelbutton}>Cancel</button> */}
        <div className="mt-md-0 mt-3" style={Fontstyling.secondaryparagraph}>
          To edit pre-populated company information, please make changes in
          BenefitPoint and return to Infused Analytics
        </div>
      </div>
    </>
  );
};

export default RebatesAndReimbursements;
